import { render, staticRenderFns } from "./RolesTableItem.vue?vue&type=template&id=572b80df&scoped=true&"
import script from "./RolesTableItem.vue?vue&type=script&lang=js&"
export * from "./RolesTableItem.vue?vue&type=script&lang=js&"
import style0 from "./RolesTableItem.vue?vue&type=style&index=0&id=572b80df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b80df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
